import React, { Component } from 'react';
import CheckoutContext from '../CheckoutContext';
import { Contact, Billing, Payment, Upsells } from './Tabs';
import { TermsAndConditionsParams } from './StepCheckout';


interface TabContentProps {
    onSetTermsAndConditions: (params: TermsAndConditionsParams) => void;
    pkgTermsConditionsCheckboxToggle: (value: string) => void;
}

export default class TabContent extends Component<TabContentProps> {
    static readonly contextType = CheckoutContext;
    context!: React.ContextType<typeof CheckoutContext>;

    render() {
        switch (this.context.currentTab) {
            case 0:
                return <Upsells />;
            case 1:
                return <Contact />;
            case 2:
                return <Billing />;
            case 3:
                return (
                    <Payment
                        onSetTermsAndConditions={this.props.onSetTermsAndConditions}
                        pkgTermsConditionsCheckboxToggle={this.props.pkgTermsConditionsCheckboxToggle}
                    />
                );
            default:
                return <></>;
        }
    }
}
